/**
 * Minimal safe telemetry sink. The app has no analytics/telemetry provider
 * yet, so reports go to `console.warn`; this module is the single seam to
 * swap in a real provider later. Callers MUST pass identifier-safe metadata
 * only (e.g. field NAMES) — never user values, prefill, or secrets (CLMS-113
 * UI contract: unknown server fields are "reported through safe telemetry
 * without value data").
 */
export function reportUnknownEditableField(fieldName: string): void {
  console.warn(
    `registration-invitation: unknown server editableFields entry ignored: ${fieldName}`,
  );
}

/**
 * 011-21 FR-050: a Member re-entry surface received `set_password_available`
 * from the first-credential status operation and rendered it as `no_action`
 * (never a credential CTA). No identifiers or values are reported.
 */
export function reportMemberSetPasswordSuppressed(): void {
  console.warn(
    "registration-invitation: member re-entry suppressed set_password_available (rendered as no_action)",
  );
}
